import { styled } from "@mui/material/styles";

export const Container = styled("div")`
  display: flex;
  height: 100vh;
  max-width: 1200px;
  margin: 0 auto;
  align-items: center;
`;
